import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import '../../css/mobile/MAdminLoginPg.css';
import btorageLogo from '../../assets/img/HeaderLogo.png'
import {useDispatch} from "react-redux";
import {setUserInfo} from "../../store/UserSlice";
import MMsgCheckModal from "../../components/mobile/MMsgCheckModal";
import imgLogo from "../../assets/img/btorage_only_img_logo.png";

function MAdminLoginPg() {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [id, setId] = useState("");
    const [password, setPassword] = useState("");
    const location = useLocation();

    const [userOutErrorMsg, setUserOutErrorMsg] = useState(false);
    const [mailDuplErrorMsg, setMailDuplErrorMsg] = useState(false);
    const [accountTypeErrorMsg, setAccountTypeErrorMsg] = useState(false);
    const [loginErrorMsg, setLoginErrorMsg] = useState(false);

    const [lgWaitingSt, setLgWaitingSt] = useState(false);
    const lgRegiWaitingMsg = "가입승인이 완료되지 않은 계정입니다."
    const [isLoading, setIsLoading] = useState(false);

    const handleChange_email = (e) => {
        setId(e.target.value);
    }
    const handleChange_password = (e) => {
        setPassword(e.target.value);
    }

    const closeLoginErrorMsg = () => {
        setLoginErrorMsg(false);
    }
    const closeMailDuplErrorMsg = () => {
        setMailDuplErrorMsg(false);
    }
    const closeUserOutErrorMsg = () => {
        setUserOutErrorMsg(false);
    }

    const confirmModalCloseFn = (() => {
        setLgWaitingSt(false);
        setIsLoading(false);
    })

    const loginCheck = async () => {
        setIsLoading(true);
        if (!id || !password) {
            setLoginErrorMsg(true);
            setIsLoading(false);
        }
        try {
            const joinVerResponse = await axios.get("/member/joinVerFl/" + id);
            if (!joinVerResponse.data) {
                console.log('이용이 정지된 계정입니다');
                setUserOutErrorMsg(true);
            } else if (joinVerResponse.data) {
                const loginResponse = await axios.post("/member/login", {
                    id: id,
                    password: password,
                    loginPath: location.pathname,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                const data = loginResponse.data;
                if (data.loginErrorType === '0') {
                    setIsLoading(false);
                    console.log('이용이 정지된 계정입니다');
                    setUserOutErrorMsg(true);
                    return;
                } else if (data.loginErrorType === '1') {
                    setIsLoading(false);
                    console.log('다른 수단으로 가입된 계정입니다');
                    setMailDuplErrorMsg(true);
                    return;
                } else if (data.loginErrorType === '2') {
                    setIsLoading(false);
                    console.log('계정 유형이 다릅니다');
                    setAccountTypeErrorMsg(true);
                    return;
                }

                const userInformation = {
                    ...loginResponse.data,
                    token: loginResponse.headers['authorization'],
                    id: id,
                    userType: data.userType,
                };

                localStorage.setItem('adminToken', loginResponse.headers.get('Authorization'));
                localStorage.setItem('adminLastLoginTime', new Date().toISOString());

                dispatch(setUserInfo(userInformation));
                navigate("/btcorpad");
            }
        } catch (error) {
            setLoginErrorMsg(true);
        }
    };

    return(
        <div className="m-a-sign-container">
            <div className="display-flex flex-column just-cont-center text-center wd-100pc p-l-15 p-r-15">
                <div className="display-flex flex-row just-cont-center ht-100 wd-100pc">
                    <img className="wd-26 ht-37 m-r-10" alt="mainLogo" src={imgLogo}/>
                    <p className="font-t-head font-s-24 m-t-5">Administrator Login</p>
                </div>
                <div className="display-flex flex-column just-cont-center gap15">
                    <div className="wd-100pc ht-auto">
                        <div className="m-a-input-frame ht-50 wd-100pc m-b-15">
                            <input onChange={handleChange_email} className="m-a-input font-t-cont" placeholder="이메일"/>
                        </div>
                        <div className="m-a-input-frame ht-50 wd-100pc">
                            <input type="password" onChange={handleChange_password} className="m-a-input font-t-cont" placeholder="비밀번호"/>
                        </div>
                    </div>
                    {loginErrorMsg ?
                        <div className="m-a-error-msg-container m-t-7">
                            <div className="m-a-error-msg font-t-cont font-s-14 p-l-7"><p className="font-c-accent">아이디 또는 비밀번호를 확인해주세요</p></div>
                        </div>
                        :
                        null
                    }
                    {userOutErrorMsg ?
                        <div className="m-a-error-msg-container m-t-7">
                            <div className="m-a-error-msg font-t-cont font-s-14 p-l-7"><p className="font-c-accent">탈퇴 처리된 계정입니다</p></div>
                        </div>
                        :
                        null
                    }
                    {mailDuplErrorMsg ?
                        <div className="m-a-error-msg-container m-t-7">
                            <div className="m-a-error-msg font-t-cont font-s-14 p-l-7"><p className="font-c-accent">다른 수단으로 가입된 계정입니다</p></div>
                        </div>
                        :
                        null
                    }
                    {accountTypeErrorMsg ?
                        <div className="m-a-error-msg-container m-t-7">
                            <div className="m-a-error-msg font-t-cont font-s-14 p-l-7"><p className="font-c-accent">계정유형이 다릅니다</p></div>
                        </div>
                        :
                        null
                    }
                    <div className="m-0-a display-flex just-cont-center m-t-45 wd-90pc gap30">
                        <div onClick={()=> navigate("/btcorpad-pwFind")} className="m-a-findPw-text font-t-cont text-active">비밀번호재설정</div>
                        <div onClick={()=> navigate("/btcorpad-join")} className="m-a-join-text font-t-cont text-active">회원가입</div>
                    </div>
                    <button className="admin-btn-C ht-50 wd-100pc">
                        <style>
                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                        </style>
                        {isLoading ? (
                            <div className="user-center">
                                <div className="spinner"></div>
                            </div>
                        ) : (
                            <div onClick={loginCheck} className="m-a-colorBt-text font-t-cont">로그인</div>
                        )}
                    </button>
                </div>
                {lgWaitingSt ? <MMsgCheckModal lgWaitingSt={lgWaitingSt} confirmModalCloseFn={confirmModalCloseFn} lgRegiWaitingMsg={lgRegiWaitingMsg}/> : null}
            </div>
        </div>
    )
}

export default MAdminLoginPg
